(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aqua-video-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aqua-video-modal')) {
    customElements.define('aqua-video-modal', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.frame = this.querySelector('.aqua-video-modal__frame');
        this.section = this.closest('.shopify-section');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.section.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-aqua-video-target]');
          if (trigger?.dataset.aquaVideoTarget !== this.dialog.id) return;
          event.preventDefault();
          this.open(trigger);
        }, options);
        this.section.addEventListener('keydown', (event) => {
          if (event.key !== ' ') return;
          const trigger = event.target.closest('[data-aqua-video-target]');
          if (trigger?.dataset.aquaVideoTarget !== this.dialog.id) return;
          event.preventDefault();
          this.open(trigger);
        }, options);
        this.dialog.addEventListener('click', (event) => {
          if (!event.target.closest('.aqua-video-modal__frame')) this.close();
        }, options);
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        }, options);
        this.dialog.addEventListener('close', () => this.cleanup(), options);
      }

      open(trigger) {
        if (this.dialog.open) return;
        this.trigger = trigger;
        this.slideshow = trigger.closest('slideshow-component');
        this.resumeSlideshow = this.slideshow?.autoplayButtonIsSetToPlay === true;
        if (this.resumeSlideshow) {
          this.slideshow.autoplayButtonIsSetToPlay = false;
          this.slideshow.pause();
        }
        const iframe = document.createElement('iframe');
        iframe.title = this.frame.dataset.videoTitle;
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(this.dataset.videoId) + '?autoplay=1&playsinline=1&rel=0';
        this.frame.replaceChildren(iframe);
        document.documentElement.classList.add('aqua-video-is-open');
        this.dialog.showModal();
      }

      close() {
        this.frame.replaceChildren();
        this.dialog.close();
      }

      cleanup() {
        this.frame.replaceChildren();
        document.documentElement.classList.remove('aqua-video-is-open');
        if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
        if (this.resumeSlideshow && this.slideshow?.isConnected) {
          this.slideshow.autoplayButtonIsSetToPlay = true;
          this.slideshow.play();
        }
        this.resumeSlideshow = false;
      }

      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.cleanup();
        this.events?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
